import { render, staticRenderFns } from "./GiftBoxCampaignsPage.vue?vue&type=template&id=618f2fb2&"
import script from "./GiftBoxCampaignsPage.vue?vue&type=script&lang=js&"
export * from "./GiftBoxCampaignsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports